module.exports = { id: "nav-hamburger", url: "/build/app/img/symbols.svg#nav-hamburger", viewBox: "", toString: function() { return this.url; } };